<template>
	<div class="animate__animated animate__fadeIn" data-wow-duration="0.8s">
		<!-- 路由导航 -->
		<div class="routerDh f-bct">
			<div class="l f-ct" @click="back()">
				<div class="t1">当前位置：</div>
				<!-- 课程中心 -->
				<el-image :src="require('@/static/icon55.png')"></el-image>
				<div class="t2">课程详情</div>
			</div>
			<div class="r f-ct" @click="back()">
				<div class="t2">返回上一页</div>
				<el-image :src="require('@/static/icon56.png')"></el-image>
			</div>
		</div>
		<!-- 课程详情 -->
		<div class="courseMsg">
			<div class="tit f-bct">
				<div class="l">
					<div class="t1">{{pageMsg.name}}</div>
					<div class="t2">创建于 {{gsTime(pageMsg.createTime)}}</div>
				</div>
				<div class="submit" @click="bmSubmit">立即报名</div>
			</div>
			<div class="detail f-bct">
				<div class="msg">
					<div class="titC">基础信息</div>
					<div class="item f-bct">
						<div class="t1">课程学习：</div>
						<div class="t2">{{pageMsg.studyHours}}</div>
					</div>
					<div class="item f-bct">
						<div class="t1">课程类型：</div>
						<div class="t2">{{pageMsg.categoryName}}</div>
					</div>
					<!-- <div class="item f-bct">
						<div class="t1">培训专业：</div>
						<div class="t2">无</div>
					</div> -->
					<div class="item f-bct">
						<div class="t1">课程负责人：</div>
						<div class="t2">{{pageMsg.directorName}}</div>
					</div>
					<div class="item f-bct">
						<div class="t1">收费标准：</div>
						<div class="t2 red">￥{{pageMsg.price}}</div>
					</div>
					<div class="item f-bct">
						<div class="t1">缴费截止日期：</div>
						<div class="t2">{{gsTime(pageMsg.applyDeadline)}}</div>
					</div>
					<div class="titC">报名要求</div>
					<div class="item f-bct">
						<div class="t1">报名学历要求：</div>
						<div class="t2">{{pageMsg.educationRequire}}</div>
					</div>
					<div class="item f-bct">
						<div class="t1">报名企业要求：</div>
						<div class="t2">{{pageMsg.companyRequire}}</div>
					</div>
					<div class="item f-bct">
						<div class="t1">社保要求：</div>
						<div class="t2">{{pageMsg.socialSecurityRequire}}</div>
					</div>
					<div class="titC">考试信息</div>
					<!-- <div class="item f-bct">
						<div class="t1">是否考试：</div>
						<div class="t2">是</div>
					</div> -->
					<div class="item f-bct">
						<div class="t1">是否补考：</div>
						<div class="t2">{{pageMsg.isAllowResit?'是':'否'}}</div>
					</div>
					<div class="item f-bct">
						<div class="t1">补考费用：</div>
						<div class="t2 red">￥{{pageMsg.resitPrice}}</div>
					</div>
					<div class="item f-bct">
						<div class="t1">可补考次数：</div>
						<div class="t2">{{pageMsg.resitNumberLimit}}</div>
					</div>
					<div class="item f-bct">
						<div class="t1">补考有效期：</div>
						<div class="t2">360天</div>
					</div>
				</div>
				<div class="richTxt">
					<div class="titC">培训内容</div>
					<div class="txt" v-html="pageMsg.content"></div>
				</div>
			</div>
		</div>
		<!-- 提示框 报名 是否报名 -->
		<div class="maskBg" @click="hbSubmit=false" v-if="hbSubmit"></div>
		<div class="subTips" v-if="hbSubmit">
			<el-image class="cha" @click="hbSubmit=false" :src="require('@/static/icon57.png')"></el-image>
			<el-image class="icon" :src="require('@/static/icon59.png')"></el-image>
			<div class="t1">报名课程</div>
			<div class="t2">您确定要报名当前课程吗？</div>
			<div class="btnBox f-ct">
				<div class="b1" @click="hbSubmit = false">返回</div>
				<div class="b2" @click="link('/userCourseFrom',{id:id,isRecheck:pageMsg.isRecheck,categoryId:pageMsg.categoryId})">确定</div>
			</div>
		</div>
		<!-- 提示框 报名 暂无资格 -->
		<!-- <div class="maskBg" @click="hbSubmit=false" v-if="hbSubmit"></div>
		<div class="subTips" v-if="hbSubmit">
			<el-image class="cha" @click="hbSubmit=false" :src="require('@/static/icon57.png')"></el-image>
			<el-image class="icon" :src="require('@/static/icon58.png')"></el-image>
			<div class="t1">暂无报名资格</div>
			<div class="t2">您的学历或企业不符合要求，暂无报名资格如有疑问，请联系平台</div>
			<div class="btnBox f-ct">
				<div class="b1">返回</div>
			</div>
		</div> -->
		<!-- 提示框 报名 企业 -->
		<div class="maskBg" @click="hbQySubmit=false" v-if="hbQySubmit"></div>
		<div class="subTips" v-if="hbQySubmit">
			<el-image class="cha" @click="hbQySubmit=false" :src="require('@/static/icon57.png')"></el-image>
			<el-image class="icon" :src="require('@/static/icon59.png')"></el-image>
			<div class="t1">报名需知</div>
			<div class="t3">
				<div class="con" v-html="pageMsgxz.content"></div>
			</div>
			<div class="btnBox f-ct">
				<div class="b1">返回</div>
				<div class="b2" @click="link('/qyClassManAdd',{id,isRecheck:pageMsg.isRecheck,categoryId:pageMsg.categoryId})">我已知悉</div>
			</div>
		</div>
		<!-- 结束 -->
	</div>
</template>
<script>
import { coursedetail,
articledetail
} from "/src/api/api.js"
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
export default {
	data(){
		return {
			id:0,
			pageHistory:[],
			hbSubmit:false,
			hbQySubmit:false,
			pageMsg:'',
			pageMsgxz:'',
		}
	},
	mounted() {
		// 获取浏览路径
		if (localStorage.getItem('pageHistory')) {
			var arr = localStorage.getItem('pageHistory')
			arr = JSON.parse(arr)
			this.pageHistory = arr
		}
		// 参数
		this.id = this.$route.query.id
		// 课程详情
		this.coursedetail()
		this.articledetail()
	},
	methods:{
		// 文章详情
		async articledetail(){
			let res = await articledetail({id:191});
			if(res.code==200){
				this.pageMsgxz = res.data
			}else{this.Tips(res.msg,'error')}
		},
		// 点击报名
		bmSubmit(){
			if(this.userType==1){
				// 普通
				this.hbSubmit = true
			}
			if(this.userType==2){
				// 企业
				this.hbQySubmit = true
			}
		},
		// 课程详情
		async coursedetail(){
			let res = await coursedetail({id:this.$route.query.id});
			if(res.code==200){
				this.pageMsg = res.data
			}else{this.Tips(res.msg,'error')}
		},
	},
	computed:{
		...mapState('userMsg',['userInfo','userType']),
	}
}
</script>
<style lang="scss">
body{
	// background: #f6f7fb;
}
</style>
<style lang="scss" scoped>
.routerDh{
	margin: 0 40px;
	margin-bottom: 24px;
	.l{
		.t1{
			font-size: 16px;
			color: #9A9DA7;
			cursor: pointer;
		}
		.el-image{
			width: 16px;
			height: 16px;
			margin: 0 2px;
		}
		.t2{
			font-size: 16px;
			color: #3B6492;
		}
	}
	.r{
		cursor: pointer;
		.t2{
			font-size: 16px;
			color: #3B6492;
		}
		.el-image{
			width: 18px;
			height: 18px;
			margin-left: 6px;
		}
	}
}
.courseMsg{
	background: #fff;
	// height: 100px;
	margin: 0 40px;
	border-radius: 20px;
	margin-top: 24px;
	padding: 0 24px;
	padding-bottom: 44px;
	.tit{
		padding-left: 4px;
		padding-top: 24px;
		padding-bottom: 24px;
		.l{
			.t1{
				font-size: 24px;
				color: #2F3541;
				font-weight: bold;
			}
			.t2{
				font-size: 16px;
				color: #A9ABB3;
				margin-top: 12px;	
			}
		}
		.submit{
			width: 146px;
			height: 46px;
			border-radius: 6px;
			background: #3B6492;
			text-align: center;
			line-height: 46px;
			font-size: 16px;
			color: #fff;
			cursor: pointer;
		}
	}
	.detail{
		align-items: stretch;
		.msg{
			width: 531px;
			border: 1px solid #eee;
			padding-bottom: 28px;
			.titC{
				margin-top: 36px;
				padding-left: 28px;
				position: relative;
				font-size: 18px;
				font-weight: 600;
				margin-bottom: 20px;
				&:first-child{
					margin-top: 24px;
				}
				&::after{
					content: '';
					position: absolute;
					left: 0;
					top: 50%;
					transform: translateY(-50%);
					width: 4px;
					height: 18px;
					background: #3B6492;
				}
			}
			.item{
				margin-top: 10px;
				padding-left: 28px;
				padding-right: 22px;
				.t1{
					color: #545964;
					font-size: 14px;
				}
				.t2{
					font-size: 14px;
					color: #545964;
				}
				.red{
					color: #FF5F5A;
				}
			}
		}
		.richTxt{
			width: 959px;
			border: 1px solid #eee;
			padding-bottom: 28px;
			background: #FAFBFC;
			.titC{
				padding: 24px 0;
				padding-left: 28px;
				position: relative;
				font-size: 18px;
				font-weight: 600;
				&::after{
					content: '';
					position: absolute;
					left: 0;
					top: 50%;
					transform: translateY(-50%);
					width: 4px;
					height: 18px;
					background: #3B6492;
				}
			}
			.riceTit{
				padding: 0 28px;
				font-size: 14px;
				color: #545964;
				font-weight: bold;margin-bottom: 16px;
			}
			.txt{
				padding: 0 28px;
				font-size: 14px;
				color: #545964;
				line-height: 30px;
				margin-bottom: 24px;
			}
		}
	}
}
.maskBg{
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.4);
	z-index: 10;
}
.subTips{
	position: fixed;
	width: 420px;
	// height: 364px;
	padding-bottom: 34px;
	background: #fff;
	border-radius: 8px;
	z-index: 11;
	top: 50%;
	left: 50%;
	transform: translateX(-50%)translateY(-50%);
	.cha{
		position: absolute;
		right: 20px;
		top: 20px;
		width: 14px;
		height: 14px;
	}
	.icon{
		display: block;
		margin: auto;
		margin-top: 48px;
		width: 90px;
		height: 90px;
	}
	.t1{
		font-size: 18px;
		color: #2F3541;
		font-weight: 600;
		text-align: center;
		margin-top: 25px;
	}
	.t2{
		font-size: 14px;
		color: #7D7D89;
		padding: 0 77px;
		text-align: center;
		margin-top: 12px;
		line-height: 28px;
	}
	.t3{
		.con{
			font-size: 14px;
			color: #7D7D89;
			height: 122px;
			overflow-y: scroll;
		}
		width: 379px;
		height: 146px;
		margin: auto;
		background: #F7F9FA;
		padding: 12px;
		margin-top: 16px;
	}
	.btnBox{
		margin-top: 28px;
		justify-content: center;
		div{
			width: 162px;
			height: 46px;
			border-radius: 6px;
			text-align: center;
			line-height: 46px;
			font-size: 16px;
			cursor: pointer;
		}
		.b1{
			background: #E9F6FF;
			color: #3B6492;
		}
		.b2{
			background: #3B6492;
			color: #fff;
			margin-left: 14px;
		}
	}
}

</style>